import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";
import client, { money } from "@/lib/api";

const List = ({ title, rows, k = "count", fmt = (v) => v, testId }) => (
  <div className="bg-white rounded-3xl p-5 pp-shadow" data-testid={testId}>
    <h3 className="font-extrabold text-pp-text">{title}</h3>
    {rows.length ? rows.map((r) => (
      <div key={r.name || r.term} className="flex justify-between text-sm py-1.5 border-b border-pp-border last:border-0"><span className="truncate pr-2 capitalize">{r.name || r.term}</span><b>{fmt(r[k])}</b></div>
    )) : <p className="text-sm text-pp-muted mt-2">Not enough data yet.</p>}
  </div>
);

export default function AdminInsights() {
  const [d, setD] = useState(null);
  useEffect(() => { client.get("/admin/insights").then((r) => setD(r.data)).catch(() => setD({})); }, []);
  if (!d) return <div className="grid place-items-center py-10"><Loader2 className="h-6 w-6 animate-spin text-pp-forest" /></div>;
  const tiles = [["Shoppers with trips", d.shoppers_with_trips], ["Avg basket", money(d.avg_basket)], ["Items per trip", d.avg_items_per_trip],
    ["Bought on deal", `${d.deal_share_pct}%`], ["Opted out of personalization", d.personalization_opted_out]];
  return (
    <div className="space-y-5" data-testid="admin-insights">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {tiles.map(([k, v]) => <div key={k} className="bg-white rounded-2xl p-4 pp-shadow"><p className="text-2xl font-extrabold text-pp-text">{v}</p><p className="text-xs text-pp-muted">{k}</p></div>)}
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="bg-white rounded-3xl p-5 pp-shadow" data-testid="insights-days">
          <h3 className="font-extrabold text-pp-text">When people shop</h3>
          <div className="h-52 mt-2"><ResponsiveContainer width="100%" height="100%">
            <BarChart data={d.shopping_days || []} margin={{ left: -20 }}><XAxis dataKey="day" tickLine={false} axisLine={false} /><YAxis allowDecimals={false} tickLine={false} axisLine={false} /><Tooltip /><Bar dataKey="trips" fill="#075B3A" radius={[8, 8, 0, 0]} /></BarChart>
          </ResponsiveContainer></div>
        </div>
        <List title="Where the money goes" rows={d.category_spend || []} k="pct" fmt={(v) => `${v}%`} testId="insights-categories" />
        <List title="Most purchased products" rows={d.top_products || []} testId="insights-products" />
        <List title="Top brands" rows={d.top_brands || []} testId="insights-brands" />
        <List title="Store share (items bought)" rows={d.store_share || []} testId="insights-stores" />
        <List title="Top searches" rows={d.top_searches || []} testId="insights-searches" />
      </div>
    </div>
  );
}
